import { sendAoIQuestionsGeneratedEvent } from '../index';
import { EventAdapter } from './EventAdapter';

type AoIQuestionsGeneratedEventAdapterParams = AoIQuestionsGeneratedEvent;

export class AoIQuestionsGeneratedEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendAoIQuestionsGeneratedEvent;
  protected intercomEventKey = null;

  constructor({
    num_aoi_selected,
    input_token,
    output_token,
    elapsed_time,
    generation_version,
    generate_explanations,
    num_mc,
    num_tf,
    num_sa,
    total_questions,
  }: AoIQuestionsGeneratedEventAdapterParams) {
    super();

    this.eventData = {
      num_aoi_selected,
      input_token,
      output_token,
      elapsed_time,
      generation_version,
      generate_explanations,
      num_mc,
      num_tf,
      num_sa,
      total_questions,
    };
  }
}

export type AoIQuestionsGeneratedEvent = {
  num_aoi_selected: number;
  input_token: number;
  output_token: number;
  elapsed_time: number;
  generation_version: string;
  generate_explanations: boolean;
  num_mc: number;
  num_tf: number;
  num_sa: number;
  total_questions: number;
};
